export enum SessionStorageKey {
  TrialExpiryBannerDismissed = 'trialExpiryBannerDismissed',
  TrialCanceledBannerDismissed = 'trialCanceledBannerDismissed'
}
